import { Pipe, PipeTransform } from '@angular/core';
import { AgentsCacheService } from '../services/agents-cache.service';

@Pipe({ name: 'lmsAgentName' })
export class AgentNamePipe implements PipeTransform {
  constructor(public agentsCache: AgentsCacheService) {}

  transform(agentId: string, role: string): string {
    const agent = this.agentsCache.getAgent(agentId);
    return agent ? agent.name : '';
  }
}
